import * as ambassadorWixBookingsV2PriceInfo from './bookings-v2-price-info-pricing.http.js';
import * as ambassadorWixBookingsV2PriceInfoTypes from './bookings-v2-price-info-pricing.types.js';
import * as ambassadorWixBookingsV2PriceInfoUniversalTypes from './bookings-v2-price-info-pricing.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function previewPrice(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2PriceInfoUniversalTypes.PreviewPriceRequest,
  ambassadorWixBookingsV2PriceInfoTypes.PreviewPriceRequest,
  ambassadorWixBookingsV2PriceInfoUniversalTypes.PreviewPriceResponse,
  ambassadorWixBookingsV2PriceInfoTypes.PreviewPriceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2PriceInfo.previewPrice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/pricing/preview',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculatePrice(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2PriceInfoUniversalTypes.CalculatePriceRequest,
  ambassadorWixBookingsV2PriceInfoTypes.CalculatePriceRequest,
  ambassadorWixBookingsV2PriceInfoUniversalTypes.CalculatePriceResponse,
  ambassadorWixBookingsV2PriceInfoTypes.CalculatePriceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2PriceInfo.calculatePrice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/pricing/calculate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PriceInfo as PriceInfoOriginal,
  PriceInfoTotalPriceOneOf as PriceInfoTotalPriceOneOfOriginal,
  BookingLineItem as BookingLineItemOriginal,
  ServiceChoice as ServiceChoiceOriginal,
  ServiceChoiceChoiceOneOf as ServiceChoiceChoiceOneOfOriginal,
  Duration as DurationOriginal,
  PricingServiceChoices as PricingServiceChoicesOriginal,
  PriceDescriptionInfo as PriceDescriptionInfoOriginal,
  PreviewPriceRequest as PreviewPriceRequestOriginal,
  PreviewPriceResponse as PreviewPriceResponseOriginal,
  CalculatePriceRequest as CalculatePriceRequestOriginal,
  Booking as BookingOriginal,
  BookingParticipantsInfoOneOf as BookingParticipantsInfoOneOfOriginal,
  MultiServiceBookingType as MultiServiceBookingTypeOriginal,
  MultiServiceBookingTypeWithLiterals as MultiServiceBookingTypeWithLiteralsOriginal,
  BookedEntity as BookedEntityOriginal,
  BookedEntityItemOneOf as BookedEntityItemOneOfOriginal,
  BookedSlot as BookedSlotOriginal,
  BookedResource as BookedResourceOriginal,
  ResourceTransparency as ResourceTransparencyOriginal,
  ResourceTransparencyWithLiterals as ResourceTransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  ResourceSelection as ResourceSelectionOriginal,
  SelectionMethod as SelectionMethodOriginal,
  SelectionMethodWithLiterals as SelectionMethodWithLiteralsOriginal,
  BookedSchedule as BookedScheduleOriginal,
  ContactDetails as ContactDetailsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  CustomFormField as CustomFormFieldOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  BookingStatus as BookingStatusOriginal,
  BookingStatusWithLiterals as BookingStatusWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  SelectedPaymentOption as SelectedPaymentOptionOriginal,
  SelectedPaymentOptionWithLiterals as SelectedPaymentOptionWithLiteralsOriginal,
  BookingSource as BookingSourceOriginal,
  Platform as PlatformOriginal,
  PlatformWithLiterals as PlatformWithLiteralsOriginal,
  Actor as ActorOriginal,
  ActorWithLiterals as ActorWithLiteralsOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  FlowControlSettings as FlowControlSettingsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ParticipantChoices as ParticipantChoicesOriginal,
  ServiceChoices as ServiceChoicesOriginal,
  MultiServiceBookingInfo as MultiServiceBookingInfoOriginal,
  BookedAddOn as BookedAddOnOriginal,
  CalculatePriceResponse as CalculatePriceResponseOriginal,
  PreviewPriceApplicationErrors as PreviewPriceApplicationErrorsOriginal,
  CalculatePriceApplicationErrors as CalculatePriceApplicationErrorsOriginal,
} from './bookings-v2-price-info-pricing.types.js';
